const DEVELOPMENT = "development";
const PRODUCTION = "production";

export const isDev = import.meta.env.MODE === DEVELOPMENT;

export const isPrd = import.meta.env.MODE === PRODUCTION;
